import s from './style.module.css';
import TableRow from "src/components/pages/Admin/Reports/ContinuingEducation/Table/TableRow";
import {CheckBoxLabel} from "@UI/CheckBox";
import React, {useEffect, useState} from "react";
import {ArrowUpOutlined} from "@ant-design/icons";
import classNames from "classnames";
import {sortAlphabeticallyAscending, sortAlphabeticallyDescending} from "@/utils/sorting";
import inPaid from '../helpers/isPaid'
const Table = ({data, setModal, onShowAll, isUniversalBalance, Paid, setState}) => {
    const head = ['№', 'Направление','ФИО', 'Стоимость', 'Общий баланс (₽)', 'Общий баланс (€)', 'Общий баланс ($)', 'Баланс по часам', 'Оплата', 'Сумма неоплат', 'Продлить', 'Комментарий']
    const [isShowDebtors, setIsShowDebtors] = useState(false)
    const [showAll, setShowAll] = useState(false)
    const [sort, setSort] = useState('');

    useEffect(() => {
        onShowAll(showAll)
    }, [showAll]);

    data = data.filter((el) => el.children !== null);
    const debtors = data.filter((order)=> !inPaid(order))

       

    // (el.children.balance && el.children.balance < 0) ||
    // (el.children.balance_euro && el.children.balance_euro < 0) ||
    // (el.children.balance_dollar && el.children.balance_dollar < 0) ||
    // (el.buy_hours && el.buy_hours < 0) ||
    // (el.next_payment_date !== null && new Date(el.next_payment_date).getTime() < new Date(Date.now()).getTime())

    const filtered = isShowDebtors ? debtors : data;

    const sorted = (sort) => {
        switch (sort) {
            case 'asc':
                return sortAlphabeticallyAscending([...filtered])
            case 'desc':
                return sortAlphabeticallyDescending([...filtered])
            default:
                return filtered
        }

    }

    const sortedData = sorted(sort)

    const handleSort = () => {
        if (sort === '') {
            setSort('asc')
        } else if (sort === 'asc') {
            setSort('desc')
        } else {
            setSort('')
        }
    }
    return (
      <>
          <div className={s.checkbox}>
              <CheckBoxLabel
                value={isShowDebtors}
                onClick={() => setIsShowDebtors(!isShowDebtors)}
                label='Показать должников'
                style={{'marginRight': 15}}
              />
              <CheckBoxLabel
                value={showAll}
                onClick={() => setShowAll(!showAll)}
                label='Показать всех учеников'
              />
          </div>
          <table className={s.table} border={'1px'}>
              <tbody>
              <tr className={s.tableHead}>
                  {head.map((el) =>
                    <th
                      key={el}
                      className={s.headEl}
                    >
                        {el === 'ФИО' ?
                            <div className={'sort'}>{el}
                                <span
                                className={classNames(s.sort, sort === 'asc' ? s.asc : sort === 'desc' ? s.desc : s.noFill)}
                                onClick={handleSort}
                                >
                                    <ArrowUpOutlined/>
                                </span>
                            </div>
                            : el
                        }
                    </th>)}
                </tr>
                <>
                    {sortedData?.map((row, ind) => 
                        <TableRow
                            isUniversalBalance={isUniversalBalance}
                            Paid={Paid}
                            key={row + ind}
                            data={row}
                            ind={ind}
                            setModal={setModal}
                            setState={setState}
                        />)
                    }
                    <tr className={s.footer}>
                        <td className={s.td}>Итого</td>
                        <td className={s.td}></td>
                        <td className={s.td}></td>
                        <td className={s.td}>{sortedData?.reduce((accumulator, currentValue) => accumulator + (Number(currentValue?.class ? currentValue.class?.classUser?.find((el) => (el?.user_id == currentValue?.children.id && el?.user_id))?.amount ?? 0 : (currentValue?.tariff?.first_price || currentValue?.tariff?.first_price === 0) ? currentValue?.tariff?.first_price :  0) ?? 0), 0)}</td>
                        <td className={s.td}>{sortedData?.reduce((accumulator, currentValue) => accumulator + (Number(currentValue?.children?.balance) ?? 0), 0)}</td>
                        <td className={s.td}>{sortedData?.reduce((accumulator, currentValue) => accumulator + (Number(currentValue?.children?.balance_euro) ?? 0), 0)}</td>
                        <td className={s.td}>{sortedData?.reduce((accumulator, currentValue) => accumulator + (Number(currentValue?.children?.balance_dollar) ?? 0), 0)}</td>
                        <td className={s.td}>
                            {sortedData?.reduce((accumulator, currentValue) => {
                                const value = currentValue?.tariff?.type === 'hour' || currentValue?.tariff?.type === 'minute'
                                    ? currentValue?.private_balance
                                    : currentValue?.buy_hours

                                return accumulator + (Number(value) || 0)
                            }, 0)}
                        </td>
                        <td className={s.td}>-</td>
                        <td className={s.td}>-</td>
                        <td className={s.td}>-</td>
                        <td className={s.td}></td>
                    </tr>
                </>
                </tbody>
            </table>
        </>
    )
}

export default Table;
